import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './LoginPage.css';
import VERSION from '../version';

const DOMAIN = '@fincasa.app';

export default function LoginPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { signIn } = useAuth();
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    const email = username.trim().toLowerCase() + DOMAIN;
    const { error: err } = await signIn(email, password);
    setLoading(false);
    if (err) {
      setError('Usuário ou senha incorretos.');
    } else {
      navigate('/');
    }
  }

  return (
    <div className="login-bg">
      <div className="login-glow" />
      <div className="login-card fade-in">
        <div className="login-logo">
          <span className="login-logo-icon">&#8383;</span>
          <div>
            <h1 className="login-title">Fincasa</h1>
            <p className="login-sub">Meu controle de gastos</p>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label>Usuário</label>
            <input
              type="text"
              placeholder="seu usuário"
              value={username}
              onChange={e => setUsername(e.target.value)}
              required
              autoFocus
              autoCapitalize="none"
              autoCorrect="off"
            />
          </div>
          <div className="form-group">
            <label>Senha</label>
            <input
              type="password"
              placeholder="••••••••"
              value={password}
              onChange={e => setPassword(e.target.value)}
              required
            />
          </div>

          {error && <div className="alert alert-error">{error}</div>}

          <button className="btn btn-primary w-full login-btn" disabled={loading}>
            {loading ? <span className="spinner" /> : null}
            {loading ? ' Entrando...' : 'Entrar'}
          </button>
          <div style={{ textAlign:'right', marginTop:4 }}>
            <Link to="/esqueci-senha" style={{ color:'var(--text3)', fontSize:'0.78rem' }}>Esqueci minha senha</Link>
          </div>
        </form>

        <div className="login-divider">ou</div>

        <Link to="/cadastro" className="btn btn-ghost w-full" style={{ textAlign:'center' }}>
          Criar minha conta
        </Link>

        <p className="login-footer">
          Fincasa · <span className="version-badge">v{VERSION}</span>
        </p>
      </div>
    </div>
  );
}
